import routes from 'pages/lost-years-claims/routes';

/**
 * This module is fucked, it has a circular dependancy that means importing other modules that are used in
 * the store makes it fail.
 */

const types = {
    INCREMENT_STEP: 'INCREMENT_STEP',
    DECREMENT_STEP: 'DECREMENT_STEP',
    SET_STEP_VALID: 'SET_STEP_VALID',
    RESET: 'RESET',
};

const state = steps => ({
    currentStepIndex: 0,
    steps,
    currentStep: null,
});

// Getters
const getters = {
    currentStep: state => state.currentStep,
    currentStepIndex: state => state.currentStepIndex,
    valid: state => index => state.steps[index] && state.steps[index].valid,
    next: (state) => {
        if (state.currentStepIndex.index + 1 < state.currentStepIndex) {
            return state.steps[state.currentStepIndex + 1];
        }
        return null;
    },
    prev: (state) => {
        if (state.currentStepIndex.index - 1 >= 0) {
            return state.steps[state.currentStepIndex - 1];
        }
        return null;
    },
    allSteps: state => state.steps,

};

// Actions
const actions = {
    setValid: ({ commit }, valid) => {
        commit(types.SET_STEP_VALID, { valid });
    },
    setStepNumberValid({ commit }, { stepNo, valid }) {
        commit(types.SET_STEP_VALID, { valid: { index: stepNo, valid: !!valid } });
    },
    reset({ commit }) {
        commit(types.RESET);
    }
};


// Mutations
const mutations = {
    [types.SET_STEP_VALID](state, { valid }) {
        if (!state.steps[valid.index]) {
            return;
        }

        state.steps[valid.index].valid = valid.valid;
    },
    [types.RESET](state) {
        state.steps.forEach(step => step.valid = false);
        state.currentStepIndex = 0;
        state.currentStep = state.steps[0];
    },
};

/**
 * Crete a step for Fatal from a route meta data
 *
 * @param route
 * @param prefix
 * @return {{route: string, name, step, valid: boolean}}
 */
const buildFromRoute = ({ route, prefix }) => ({
    route: route,
    name: route.meta.name,
    store: route.meta.store,
    step: route.meta.step,
    valid: false,
});

/**
 * Is the previous step valid.
 *
 * @param current
 */


const steps = routes[0].children.map(route => buildFromRoute({ route, prefix: 'lost-years' }));

export default {
    namespaced: true,
    state: state(steps),
    getters,
    actions,
    mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/lost/step.js